var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPenHomePage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83 41.5C83 30.4935 78.6277 19.9378 70.8449 12.1551C63.0622 4.37231 52.5065 8.30967e-07 41.5 0C30.4935 -8.30966e-07 19.9378 4.37231 12.1551 12.1551C4.37231 19.9378 1.66193e-06 30.4935 0 41.5H1.66C1.66 30.9338 5.85742 20.8003 13.3289 13.3289C20.8003 5.85741 30.9338 1.66 41.5 1.66C52.0662 1.66 62.1997 5.85742 69.6711 13.3289C77.1426 20.8003 81.34 30.9338 81.34 41.5H83Z",
    fill: "url(#paint0_linear_6105_81476)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6664 33.0664C57.6676 32.847 57.6256 32.6296 57.5427 32.4265C57.4597 32.2235 57.3375 32.0388 57.183 31.883L50.1164 24.8164C49.9606 24.6619 49.7759 24.5397 49.5729 24.4568C49.3698 24.3738 49.1524 24.3318 48.933 24.333C48.7137 24.3318 48.4963 24.3738 48.2932 24.4568C48.0901 24.5397 47.9054 24.6619 47.7497 24.8164L43.033 29.533L24.8164 47.7497C24.6619 47.9054 24.5397 48.0901 24.4568 48.2932C24.3738 48.4963 24.3318 48.7137 24.333 48.933V55.9997C24.333 56.4417 24.5086 56.8657 24.8212 57.1782C25.1338 57.4908 25.5577 57.6664 25.9997 57.6664H33.0664C33.2996 57.6791 33.5329 57.6426 33.7511 57.5593C33.9693 57.4761 34.1676 57.3479 34.333 57.183L52.4497 38.9664L57.183 34.333C57.3352 34.1715 57.4591 33.9856 57.5497 33.783C57.5658 33.6502 57.5658 33.5159 57.5497 33.383C57.5575 33.3055 57.5575 33.2273 57.5497 33.1497L57.6664 33.0664ZM32.383 54.333H27.6664V49.6164L44.2164 33.0664L48.933 37.783L32.383 54.333ZM51.283 35.433L46.5664 30.7164L48.933 28.3664L53.633 33.0664L51.283 35.433Z",
    fill: "url(#paint1_linear_6105_81476)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6105_81476",
    x1: 0,
    y1: 41.5,
    x2: 83,
    y2: 41.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F45FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6365"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6105_81476",
    x1: 24.333,
    y1: 41.0009,
    x2: 57.6664,
    y2: 41.0009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F45FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6365"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenHomePage);
export default __webpack_public_path__ + "static/media/penHomePage.2a7377bb.svg";
export { ForwardRef as ReactComponent };